module.exports = __webpack_public_path__ + "static/media/grounding.fccffa0b.png";